import _styled from "@emotion/styled-base";
import { COLORS, FONT } from '../../../constants';

var StyledBadge = _styled("span", {
  target: "e1ilgel80",
  label: "StyledBadge"
})({
  alignItems: 'center',
  borderRadius: '50%',
  display: 'inline-flex',
  fontSize: 10,
  fontWeight: 700,
  height: 20,
  justifyContent: 'center',
  lineHeight: 'normal',
  margin: '0 0 0 6px',
  width: 20,
  backgroundColor: COLORS.blues.primary,
  color: COLORS.white,
  fontFamily: FONT.family
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImJhZGdlLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVrQiIsImZpbGUiOiJiYWRnZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IENPTE9SUywgRk9OVCB9IGZyb20gJy4uLy4uLy4uL2NvbnN0YW50cyc7XG52YXIgU3R5bGVkQmFkZ2UgPSBzdHlsZWQuc3Bhbih7XG4gICAgYWxpZ25JdGVtczogJ2NlbnRlcicsXG4gICAgYm9yZGVyUmFkaXVzOiAnNTAlJyxcbiAgICBkaXNwbGF5OiAnaW5saW5lLWZsZXgnLFxuICAgIGZvbnRTaXplOiAxMCxcbiAgICBmb250V2VpZ2h0OiA3MDAsXG4gICAgaGVpZ2h0OiAyMCxcbiAgICBqdXN0aWZ5Q29udGVudDogJ2NlbnRlcicsXG4gICAgbGluZUhlaWdodDogJ25vcm1hbCcsXG4gICAgbWFyZ2luOiAnMCAwIDAgNnB4JyxcbiAgICB3aWR0aDogMjAsXG4gICAgYmFja2dyb3VuZENvbG9yOiBDT0xPUlMuYmx1ZXMucHJpbWFyeSxcbiAgICBjb2xvcjogQ09MT1JTLndoaXRlLFxuICAgIGZvbnRGYW1pbHk6IEZPTlQuZmFtaWx5LFxufSk7XG5leHBvcnQgZGVmYXVsdCBTdHlsZWRCYWRnZTtcbiJdfQ== */");

export default StyledBadge;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Header/filters/badge.js
// module id = 362
// module chunks = 0